import { api } from "./client";
import type {
  Application,
  ApplicationDetail,
  ArtifactContent,
  ArtifactKind,
  Job,
} from "./types";

export const applicationsApi = {
  list: (includeArchived = false) =>
    api.get<Application[]>(`/api/applications?include_archived=${includeArchived}`),

  read: (id: string) => api.get<ApplicationDetail>(`/api/applications/${id}`),

  create: (job_ad_md: string, source_url = "", generate = true) =>
    api.post<ApplicationDetail>("/api/applications", { job_ad_md, source_url, generate }),

  update: (id: string, changes: Partial<Application>) =>
    api.patch<Application>(`/api/applications/${id}`, changes),

  remove: (id: string) => api.del<void>(`/api/applications/${id}`),

  generate: (id: string, kinds?: ArtifactKind[]) =>
    api.post<{ job_id: string }>(`/api/applications/${id}/generate`, { kinds: kinds ?? null }),
};

export const artifactsApi = {
  read: (id: string) => api.get<ArtifactContent>(`/api/artifacts/${id}`),
  save: (id: string, content_text: string) =>
    api.put<ArtifactContent>(`/api/artifacts/${id}`, { content_text }),
  downloadUrl: (id: string) => `/api/artifacts/${id}/download`,
  inlineUrl: (id: string) => `/api/artifacts/${id}/inline`,
};

export const jobsApi = {
  read: (id: string) => api.get<Job>(`/api/jobs/${id}`),
  eventsUrl: (id: string) => `/api/jobs/${id}/events`,
};
